import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import { useEffect, useState } from "react";

export default function Header() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isLanding = location.pathname === "/";

  const handleScrollTo = (e, id) => {
    e.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      window.scrollTo({
        top: target.offsetTop - 80,
        behavior: "smooth",
      });
      setMobileOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isLanding
          ? scrolled
            ? "bg-white/90 backdrop-blur-md shadow-sm"
            : "bg-transparent"
          : "bg-white shadow-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center px-4 sm:px-6 py-4 gap-4 md:gap-12">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-3 hover:opacity-90 transition-opacity flex-shrink-0"
        >
          <img
            src={logo}
            alt="SmartPackr logo"
            className="h-12 sm:h-14 md:h-16 w-auto object-contain flex-shrink-0"
          />
        </Link>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8 text-base md:text-lg font-medium">
          {isLanding ? (
            <>
              <a
                href="#book"
                onClick={(e) => handleScrollTo(e, "book")}
                className={`transition-colors ${
                  scrolled
                    ? "text-gray-700 hover:text-[#6B91B5]"
                    : "text-white hover:text-gray-200"
                }`}
              >
                How It Works
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, "features")}
                className={`transition-colors ${
                  scrolled
                    ? "text-gray-700 hover:text-[#6B91B5]"
                    : "text-white hover:text-gray-200"
                }`}
              >
                Features
              </a>
              <a
                href="#blog"
                onClick={(e) => handleScrollTo(e, "blog")}
                className={`transition-colors ${
                  scrolled
                    ? "text-gray-700 hover:text-[#6B91B5]"
                    : "text-white hover:text-gray-200"
                }`}
              >
                Blog
              </a>
            </>
          ) : (
            <>
              <Link
                to="/app"
                className={`transition-colors ${
                  location.pathname === "/app"
                    ? "text-brandPink font-semibold border-b-2 border-brandPink pb-1"
                    : "text-gray-600 hover:text-brandBlue"
                }`}
              >
                Packing App
              </Link>
              <Link
                to="/blog"
                className={`transition-colors ${
                  location.pathname.startsWith("/blog")
                    ? "text-brandPink font-semibold border-b-2 border-brandPink pb-1"
                    : "text-gray-600 hover:text-brandBlue"
                }`}
              >
                Blog
              </Link>
            </>
          )}

          <Link
            to="/app"
            className="px-4 py-2 rounded-full font-semibold shadow-sm hover:shadow-md transition bg-gradient-to-r from-[#6B91B5] to-[#EE4A72] text-white"
          >
            Get Started
          </Link>
        </div>

        {/* Mobile actions: Get Started + Hamburger */}
        <div className="flex items-center gap-2 md:hidden">
          <Link
            to="/app"
            className={`px-3 py-2 rounded-full font-semibold shadow-sm transition bg-gradient-to-r from-[#6B91B5] to-[#EE4A72] text-white text-sm`}
          >
            Get Started
          </Link>
          <button
            aria-label="Open menu"
            onClick={() => setMobileOpen((o) => !o)}
            className={`p-2 rounded-md ${
              isLanding && !scrolled ? "text-white" : "text-gray-700"
            }`}
          >
            {/* Hamburger icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <div className="md:hidden border-t bg-white/95 backdrop-blur-md shadow-sm">
          <div className="px-4 py-3 flex flex-col text-base font-medium">
            {isLanding ? (
              <>
                <a
                  href="#book"
                  onClick={(e) => handleScrollTo(e, "book")}
                  className="py-2 text-gray-700 hover:text-[#6B91B5]"
                >
                  How It Works
                </a>
                <a
                  href="#features"
                  onClick={(e) => handleScrollTo(e, "features")}
                  className="py-2 text-gray-700 hover:text-[#6B91B5]"
                >
                  Features
                </a>
                <a
                  href="#blog"
                  onClick={(e) => handleScrollTo(e, "blog")}
                  className="py-2 text-gray-700 hover:text-[#6B91B5]"
                >
                  Blog
                </a>
              </>
            ) : (
              <>
                <Link
                  to="/app"
                  onClick={() => setMobileOpen(false)}
                  className="py-2 text-gray-700 hover:text-[#6B91B5]"
                >
                  Packing App
                </Link>
                <Link
                  to="/blog"
                  onClick={() => setMobileOpen(false)}
                  className="py-2 text-gray-700 hover:text-[#6B91B5]"
                >
                  Blog
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
